import { updateClientInfoCookie } from '@commenda/auth';
import { Timezone } from '@commenda/types';
import { RoleInOrganization } from '@commenda/types/src/user';
import { fetcher } from '@commenda/utils';

type UserAdditionalInformationParams = {
  roleInOrganization?: RoleInOrganization;
};

export async function updateUser(
  userId: string,
  body: {
    name?: string;
    avatar?: string | null;
    timeZone?: Timezone;
    phoneNumber?: string;
    userAdditionalInformation?: UserAdditionalInformationParams;
    hasSeenProductRevampIntroBanner?: boolean;
  },
  options: {
    refreshCookie?: boolean;
  } = {
    refreshCookie: true,
  }
) {
  const res = await fetcher(`user/${userId}`, {
    method: 'POST',
    body,
  });

  // If the update was successful and refreshCookie is true, update the client info cookie
  if (res.ok && options.refreshCookie && typeof window !== 'undefined') {
    // Only update fields that are part of the RequestUser type
    if (body.name) {
      updateClientInfoCookie({
        name: body.name,
      });
    }
  }

  return res;
}
